import { HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type FlexDivType = { children: ReactNode; className?: string } & HTMLAttributes<HTMLDivElement>;

export const FlexRow = ({ children, className, ...props }: FlexDivType) => {
  return (
    <div className={twMerge(`flex flex-row`, className)} {...props}>
      {children}
    </div>
  );
};

export const FlexCol = function ({ children, className, ...props }: FlexDivType) {
  return (
    <div className={twMerge(`flex flex-col`, className)} {...props}>
      {children}
    </div>
  );
};

export function FlexRowCenter({ children, className, ...rest }: { children: ReactNode; className?: string }) {
  return (
    <FlexRow className={twMerge("items-center justify-center", className)} {...rest}>
      {children}
    </FlexRow>
  );
}

export function FlexColCenter({ children, className, ...rest }: { children: ReactNode; className?: string }) {
  return (
    <FlexCol className={twMerge("items-center justify-center", className)} {...rest}>
      {children}
    </FlexCol>
  );
}
